module.exports = __webpack_public_path__ + "static/media/sante-milieu-pro-2.d25b920d.jpg";